import { render, staticRenderFns } from "./IQThinkingPulsatingIcon.vue?vue&type=template&id=18c8e6ce&scoped=true"
import script from "./IQThinkingPulsatingIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./IQThinkingPulsatingIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQThinkingPulsatingIcon.vue?vue&type=style&index=0&id=18c8e6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8e6ce",
  null
  
)

export default component.exports